<template>
  <div> 
    <a href="auxele.cn/gs"></a>
  </div>
</template>

<script>

export default {
    data(){
        return {
        }
    },
    methods:{
    },
    mounted(){
        window.location.href = 'https://www.auxele.cn/gs';
    }
}
</script>

<style lang="scss" scoped>

</style>